module.exports = __webpack_public_path__ + "static/media/EcoPower China.578259e9.webp";